// // frontend/src/pages/SetPassword.jsx
// import { useState } from "react";
// import { useNavigate, useSearchParams, Link } from "react-router-dom";
// import axios from "axios";

// export default function SetPassword() {
//   const [searchParams] = useSearchParams();
//   // const token = searchParams.get("token"); // token from email link
//   const rawToken = searchParams.get("token");
//   const token = rawToken ? decodeURIComponent(rawToken).trim() : "";
//   const emailFromQuery = searchParams.get("email") || "";
//   const [email, setEmail] = useState(emailFromQuery); // pre-fill email if provided
//   const [password, setPassword] = useState("");
//   const [confirm, setConfirm] = useState("");
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

//   // Password rule:
//   // - at least 8 chars
//   // - at least one letter
//   // - at least one digit
//   // - at least one special char from @ # $ % ! ^ & * ( ) _
//   const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%!^&*()_])[A-Za-z\d@#$%!^&*()_]{8,}$/;

//   const validate = () => {
//     if (!email || !/^\S+@\S+\.\S+$/.test(email)) return "Please enter a valid email.";
//     if (!password || !confirm) return "Please fill in both password fields.";
//     if (password !== confirm) return "Passwords do not match.";
//     if (!token) return "Invalid or missing token.";
//     if (password.length < 8) return "Password must be at least 8 characters long.";
//     if (!passwordRegex.test(password)) {
//       return "Password must include letters, numbers, and a special character (one of @ # $ % ! ^ & * ( ) _).";
//     }
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage("");

//     const err = validate();
//     if (err) {
//       setMessage("⚠️ " + err);
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await axios.post(`${API_BASE}/api/students/set-password`, {
//         email: email.trim().toLowerCase(),
//         token,
//         password,
//       });

//       const successMsg = res.data?.message || "Password set successfully.";
//       setMessage("✅ " + successMsg);

//       // after success, redirect to candidate login
//       setTimeout(() => {
//         navigate("/candidate");
//       }, 1200);
//     } catch (err) {
//       console.error("reset password error:", err);
//       const errMsg = err.response?.data?.message || "Failed to set password.";
//       setMessage("❌ " + errMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container my-5">
//       <div className="card shadow p-4 mx-auto" style={{ maxWidth: "480px" }}>
//         <h2 className="mb-4 fw-bold text-center text-dark">Set Your Password</h2>

//         <form onSubmit={handleSubmit} noValidate>
//           <div className="mb-3">
//             <label className="form-label">Email</label>
//             <input
//               type="email"
//               className="form-control"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               placeholder="you@example.com"
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label">New Password</label>
//             <input
//               type="password"
//               className="form-control"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//               placeholder="At least 8 chars, include letter, number & special char"
//               aria-describedby="pwdHelp"
//             />
//             <div id="pwdHelp" className="form-text">
//               Use at least 8 characters, including letters, numbers and a special character: @ # $ % ! ^ &amp; * ( ) _
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Confirm Password</label>
//             <input
//               type="password"
//               className="form-control"
//               value={confirm}
//               onChange={(e) => setConfirm(e.target.value)}
//               required
//               placeholder="Confirm your password"
//             />
//           </div>

//           <button
//             type="submit"
//             className="btn btn-gold w-100 fw-bold"
//             disabled={loading}
//           >
//             {loading ? "Setting..." : "Set Password"}
//           </button>
//         </form>

//         {message && (
//           <div className={`alert mt-3 ${message.startsWith("✅") ? "alert-success" : "alert-danger"}`} role="alert">
//             {message}
//           </div>
//         )}

//         <div className="mt-3 text-center">
//           <small>
//             Already have an account? <Link to="/candidate">Go to Candidate Login</Link>
//           </small>
//         </div>
//       </div>
//     </div>
//   );
// }


// frontend/src/pages/SetPassword.jsx
import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "../utils/api"; // ✅ CHANGED

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const rawToken = searchParams.get("token");
  const token = rawToken ? decodeURIComponent(rawToken).trim() : "";
  const emailFromQuery = searchParams.get("email") || "";
  const [email, setEmail] = useState(emailFromQuery);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Password rule
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%!^&*()_])[A-Za-z\d@#$%!^&*()_]{8,}$/;

  const validate = () => {
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) return "Please enter a valid email.";
    if (!password || !confirm) return "Please fill in both password fields.";
    if (password !== confirm) return "Passwords do not match.";
    if (!token) return "Invalid or missing token.";
    if (password.length < 8) return "Password must be at least 8 characters long.";
    if (!passwordRegex.test(password)) {
      return "Password must include letters, numbers, and a special character (one of @ # $ % ! ^ & * ( ) _).";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const err = validate();
    if (err) {
      setMessage("⚠️ " + err);
      return;
    }

    setLoading(true);
    try {
      const res = await api.post(`/api/students/set-password`, { // ✅ CHANGED
        email: email.trim().toLowerCase(),
        token,
        password,
      });

      const successMsg = res.data?.message || "Password set successfully.";
      setMessage("✅ " + successMsg);

      setTimeout(() => {
        navigate("/candidate");
      }, 1200);

    } catch (err) {
      console.error("reset password error:", err);
      const errMsg = err.response?.data?.message || "Failed to set password.";
      setMessage("❌ " + errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5">
      <div className="card shadow p-4 mx-auto" style={{ maxWidth: "480px" }}>
        <h2 className="mb-4 fw-bold text-center text-dark">Set Your Password</h2>

        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="At least 8 chars, include letter, number & special char"
              aria-describedby="pwdHelp"
            />
            <div id="pwdHelp" className="form-text">
              Use at least 8 characters, including letters, numbers and a special character: @ # $ % ! ^ &amp; * ( ) _
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              placeholder="Confirm your password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-gold w-100 fw-bold"
            disabled={loading}
          >
            {loading ? "Setting..." : "Set Password"}
          </button>
        </form>

        {message && (
          <div className={`alert mt-3 ${message.startsWith("✅") ? "alert-success" : "alert-danger"}`} role="alert">
            {message}
          </div>
        )}

        <div className="mt-3 text-center">
          <small>
            Already have an account? <Link to="/candidate">Go to Candidate Login</Link>
          </small>
        </div>
      </div>
    </div>
  );
}